import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mysiteCount'
})
export class MysiteCountPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    return value === 0 ? '' : value < 9 && value > 0 ? '0' + value.toString() : value.toString();
  }

}
